import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useMemo } from 'react';
import { noop } from "../../utils/noop";
import { MenuGroup } from "./MenuGroup";
var defaultRadioGroupContext = {
  checked: null,
  onChange: noop
};
export var MenuRadioGroupContext = React.createContext(defaultRadioGroupContext);
/**
 * MenuRadioGroup
 *
 * A state management wrapper for a list
 * of MenuRadioItem components. It composes MenuGroup.
 */

export function MenuRadioGroup(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["checked", "onChange", "children"]);

  var radioGroupContext = useMemo(function () {
    return {
      onChange: onChange,
      checked: checked
    };
  }, [onChange, checked]);
  return /*#__PURE__*/React.createElement(MenuGroup, other, /*#__PURE__*/React.createElement(MenuRadioGroupContext.Provider, {
    value: radioGroupContext
  }, children));
}